"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteCatalogButton = exports.DeleteButtonWrap = exports.CatalogCardInfoFormContent = exports.CatalogCardInfoImage = exports.CatalogCardInfoFormWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const catalogCardInfoFormWrapCss = (0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.catalogs.catalogCardInfoFormWrap);
const deleteButtonWrapCss = (0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.catalogs.catalogDeleteButtonWrap);
const catalogCardInfoImageCss = (0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.catalogs.catalogCardInfoImage);
const catalogCardInfoFormContentCss = (0, util_theme_sxc_1.sx2CssThemeFn)(({ theme }) => theme.catalogs.catalogCardInfoFormContent);
exports.CatalogCardInfoFormWrap = styled_components_1.default.div(catalogCardInfoFormWrapCss);
exports.CatalogCardInfoImage = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)(catalogCardInfoImageCss);
exports.CatalogCardInfoFormContent = styled_components_1.default.div(catalogCardInfoFormContentCss);
exports.DeleteButtonWrap = styled_components_1.default.div(deleteButtonWrapCss);
exports.DeleteCatalogButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon).attrs({
    variant: 'iconBtn',
    icon: { name: 'delete' },
    testId: `delete`,
})(({ theme }) => theme.buttons.iconBtn, {
    padding: '0px',
});
//# sourceMappingURL=fdr-catalogs-ordered-card.styles.js.map